export const GET_PRIZES = 'GET_PRIZES';

export const UPDATE_PRIZE = 'UPDATE_PRIZE';

export const GET_LOTTERY_RECORD_LIST = 'GET_LOTTERY_RECORD_LIST';

export const GET_LOTTERY_HARVEST = 'GET_LOTTERY_HARVEST';

export const UPDATE_PRIZE_ORDER_SHIP = 'UPDATE_PRIZE_ORDER_SHIP';